import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Tab } from 'semantic-ui-react';
import SettingPricePane from './SettingPricePane';

import styles from './SettingPrice.module.scss';

const DEFAULT_DATA = {
  data: {
    id: '',
    currency: '',
    unitName: '',
    prices: [],
  },
  id: '',
  description: '',
};

const SettingPrice = React.memo(
  ({ canView, canEdit, defaultData, settingPrice, isSubmitting, error, onCreate, onUpdate }) => {
    const [t] = useTranslation();

    const [settingPriceElectricity, setSettingPriceElectricity] = useState(DEFAULT_DATA);
    const [settingPriceWater, setSettingPriceWater] = useState(DEFAULT_DATA);
    const [settingPriceGas, setSettingPriceGas] = useState(DEFAULT_DATA);

    useEffect(() => {
      const priceElectricity = settingPrice.find((it) => it.name === 'electricity-price');
      const priceWater = settingPrice.find((it) => it.name === 'water-price');
      const priceGas = settingPrice.find((it) => it.name === 'gas-price');
      if (priceElectricity) setSettingPriceElectricity(priceElectricity);
      if (priceWater) setSettingPriceWater(priceWater);
      if (priceGas) setSettingPriceGas(priceGas);
    }, [settingPrice]);
    const panes = [
      {
        menuItem: t('common.settingPrice.electric'),
        render: () => (
          <SettingPricePane
            isEditable={canEdit}
            key="electricity-price"
            defaultData={{
              ...defaultData,
              id: settingPriceElectricity.id,
              description: settingPriceElectricity.description,
              currency: settingPriceElectricity.data.currency,
              unitName: settingPriceElectricity.data.unitName,
            }}
            name="electricity-price"
            settingPrice={settingPriceElectricity}
            error={error}
            onCreate={onCreate}
            onUpdate={onUpdate}
            isSubmitting={isSubmitting}
          />
        ),
      },
      {
        menuItem: t('common.settingPrice.water'),
        render: () => (
          <SettingPricePane
            isEditable={canEdit}
            key="water-price"
            defaultData={{
              ...defaultData,
              id: settingPriceWater.id,
              description: settingPriceWater.description,
              currency: settingPriceWater.data.currency,
              unitName: settingPriceWater.data.unitName,
            }}
            name="water-price"
            settingPrice={settingPriceWater}
            error={error}
            onCreate={onCreate}
            onUpdate={onUpdate}
            isSubmitting={isSubmitting}
          />
        ),
      },
      {
        menuItem: t('common.settingPrice.gas'),
        render: () => (
          <SettingPricePane
            isEditable={canEdit}
            key="gas-price"
            defaultData={{
              ...defaultData,
              id: settingPriceGas.id,
              description: settingPriceGas.description,
              currency: settingPriceGas.data.currency,
              unitName: settingPriceGas.data.unitName,
            }}
            name="gas-price"
            settingPrice={settingPriceGas}
            error={error}
            onCreate={onCreate}
            onUpdate={onUpdate}
            isSubmitting={isSubmitting}
          />
        ),
      },
    ];

    return (
      <>
        {canView && (
          <div className={styles.devicesWrapper}>
            <Tab panes={panes} />
          </div>
        )}
      </>
    );
  },
);

SettingPrice.propTypes = {
  defaultData: PropTypes.objectOf(PropTypes.any).isRequired,
  canView: PropTypes.bool.isRequired,
  canEdit: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  settingPrice: PropTypes.arrayOf(PropTypes.any).isRequired,
  error: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  onCreate: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
};

SettingPrice.defaultProps = {
  error: undefined,
};

export default SettingPrice;
